import React from 'react';
import { Flex, Row, Space, Image, Typography } from 'antd';
import { Link } from 'react-router-dom';

import Logo from '../../../static/images/logo.png';
import Rfrit from '../../../static/images/rfrit-logo.svg';
import { contacts, links, payments } from './utils/data';
import { useWindowSize } from '../../../hooks/useWindowSize';
import * as S from './Footer.style';

export const Footer = ({
    contactsRef,
}: {
    contactsRef?: Ref<HTMLDivElement>;
}) => {
    const { size } = useWindowSize();

    return (
        <S.Wrapper ref={contactsRef}>
            <S.Container>
                <Row style={{ width: '100%' }}>
                    <S.Column
                        style={{ marginBottom: '1rem' }}
                        xs={24}
                        lg={12}
                        size={size}
                    >
                        <Link to={'/'}>
                            <img height={22} src={Logo} alt={'logo spodial'} />
                        </Link>
                    </S.Column>
                    <S.Column xs={24} lg={5} size={size}>
                        <div>
                            {contacts.map((c, index) => (
                                <S.Contact size={size} key={index}>
                                    <img src={c.src} alt={c.alt} />
                                    <Link
                                        to={c.href}
                                        rel='noopener noreferrer'
                                        target='_blank'
                                    >
                                        <S.Link>{c.name}</S.Link>
                                    </Link>
                                </S.Contact>
                            ))}
                        </div>
                    </S.Column>
                    <S.Column xs={24} lg={7} size={size}>
                        <Space direction={'vertical'} size={'middle'}>
                            {links.map((link, index) => (
                                <Link key={index} to={link.href}>
                                    <S.Link>{link.name}</S.Link>
                                </Link>
                            ))}
                        </Space>
                    </S.Column>
                </Row>

                <S.Support size={size} style={{ width: '100%' }}>
                    <Flex
                        style={{
                            cursor: 'pointer',
                        }}
                        onClick={() =>
                            window.open('https://rfrit.ru/', '_blank')
                        }
                        vertical={false}
                        gap={8}
                        align={'center'}
                    >
                        <Typography.Link>При поддержке: </Typography.Link>
                        <Image preview={false} src={Rfrit} />
                    </Flex>
                </S.Support>

                <S.Payments size={size}>
                    <Space direction={'horizontal'} size={'large'}>
                        {payments.map((p, index) => (
                            <img key={index} src={p.src} alt={p.alt} />
                        ))}
                    </Space>
                </S.Payments>
            </S.Container>
        </S.Wrapper>
    );
};
